import { useEffect, useState } from 'react';
import './capsule.css';
import { HoiPoiCapsule, CapsuleCorpLogo, SmokePuffArt } from './CapsuleArt';
import { LOADER_TIPS, TIP_ROTATE_MS, SLOW_LOAD_MS, PUFFS, BURST_ANGLES, ORBIT, SPARKLES } from './capsuleConfig';

const Tips = () => {
  const [i, setI] = useState(() => Math.floor(Math.random() * LOADER_TIPS.length));
  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % LOADER_TIPS.length), TIP_ROTATE_MS);
    return () => clearInterval(t);
  }, []);
  return (
    <p className="cc-tip" data-testid="capsule-loader-tip">
      <span key={i} className="cc-tip-text"><span className="cc-tip-label">TIP</span>{LOADER_TIPS[i]}</span>
    </p>
  );
};

const SlowNotice = () => {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSlow(true), SLOW_LOAD_MS);
    return () => clearTimeout(t);
  }, []);
  if (!slow) return null;
  return (
    <div className="cc-retry" data-testid="capsule-loader-slow">
      <span>This is taking longer than usual…</span>
      <button onClick={() => window.location.reload()} data-testid="capsule-loader-retry">Retry</button>
    </div>
  );
};

// The Capsule Corp loading screen itself (logo, idle details, tips)
const LoadingScreen = () => (
  <>
    <div className="cc-stage">
      <div className="cc-orbit" aria-hidden="true">
        {ORBIT.map((o) => (
          <div key={o.a} className="cc-orbit-item" style={{ '--a': `${o.a}deg`, '--bd': o.bd }}>
            <div><img src={o.ball} alt="" draggable={false} className="cc-orbit-ball" /></div>
          </div>
        ))}
      </div>
      {SPARKLES.map((s, i) => <span key={i} className="cc-sparkle" style={{ left: s.left, top: s.top, '--d': s.d }} />)}
      <div className="cc-logo"><CapsuleCorpLogo /></div>
    </div>
    <Tips />
    <SlowNotice />
  </>
);

// Capsule drops → shakes → pops in smoke → the loading screen bursts out of it
const CapsuleDeploy = () => (
  <div className="cc-deploy" aria-hidden="true">
    <div className="cc-deploy-stage">
      <div className="cc-capsule-shadow" />
      <div className="cc-capsule"><HoiPoiCapsule /></div>
      <div className="cc-flash" />
      <div className="cc-burst">
        {BURST_ANGLES.map((r) => <span key={r} style={{ '--r': `${r}deg` }} />)}
      </div>
      {PUFFS.map((p, i) => (
        <div key={i} className="cc-puff" style={{ '--dx': `${p.dx}px`, '--dy': `${p.dy}px`, '--size': `${p.size}%`, '--s': p.s, '--d': `${p.d}s` }}>
          <SmokePuffArt id={i} />
        </div>
      ))}
    </div>
  </div>
);

// deploy = full intro (site open); otherwise the screen appears directly
export const CapsuleScene = ({ deploy = false }) => (
  <div className={`cc-root ${deploy ? 'cc-mode-deploy' : 'cc-skip-intro'}`} role="status" aria-live="polite" data-testid="capsule-loader">
    <span className="sr-only">Loading…</span>
    <div className="cc-screen" data-testid="capsule-loading-screen"><LoadingScreen /></div>
    {deploy && <CapsuleDeploy />}
  </div>
);

export default CapsuleScene;
